var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendingFailedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 120,
    viewBox: "0 0 222 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4960_13183)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.9803,
    y: 22.3758,
    width: 61.0141,
    height: 106.613,
    rx: 7.25,
    transform: "rotate(-22.5472 40.9803 22.3758)",
    fill: "white",
    stroke: "#C7C7CC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4960_13183",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.3173,
    cy: 20.0213,
    rx: 1.56285,
    ry: 1.55932,
    transform: "rotate(-22.5472 62.3173 20.0213)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.3173,
    cy: 20.0213,
    rx: 1.56285,
    ry: 1.55932,
    transform: "rotate(-22.5472 62.3173 20.0213)",
    fill: "#C7C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9136 20.1889C61.8186 19.9602 61.9293 19.7052 62.1483 19.6143L63.6821 23.3085C65.4955 22.5557 66.3632 20.4746 65.6078 18.6551L61.9136 20.1889ZM62.1483 19.6143C62.3674 19.5233 62.6261 19.6249 62.721 19.8537L59.0268 21.3874C59.7822 23.2069 61.8688 24.0614 63.6821 23.3085L62.1483 19.6143ZM62.721 19.8537C62.816 20.0824 62.7053 20.3373 62.4863 20.4283L60.9525 16.734C59.1391 17.4869 58.2714 19.568 59.0268 21.3874L62.721 19.8537ZM62.4863 20.4283C62.2673 20.5192 62.0085 20.4176 61.9136 20.1889L65.6078 18.6551C64.8524 16.8357 62.7659 15.9812 60.9525 16.734L62.4863 20.4283Z",
    fill: "#C7C7CC",
    mask: "url(#path-2-inside-1_4960_13183)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1064,
    y: 17.604,
    width: 10.9435,
    height: 1.55932,
    rx: 0.779658,
    transform: "rotate(-22.5472 66.1064 17.604)",
    fill: "#C7C7CC",
    stroke: "#C7C7CC",
    strokeWidth: 1.55932
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4960_13183)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.732,
    cy: 103.594,
    rx: 4.16761,
    ry: 4.15818,
    transform: "rotate(-22.5472 107.732 103.594)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.889 102.283C111.61 104.02 110.784 106.017 109.039 106.741C107.294 107.466 105.297 106.641 104.576 104.904C103.855 103.167 104.681 101.17 106.425 100.446C108.17 99.7216 110.167 100.546 110.889 102.283Z",
    stroke: "#C7C7CC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4960_13183)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.4915,
    y: 32.0438,
    width: 54.7436,
    height: 82.9332,
    rx: 4,
    transform: "rotate(-22.5472 48.4915 32.0438)",
    fill: "#EDF0F2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.4717,
    y: 32.4489,
    width: 53.2436,
    height: 81.4332,
    rx: 3.25,
    transform: "rotate(-22.5472 49.4717 32.4489)",
    stroke: "#C7C7CC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4960_13183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.774 42.7534C112.148 38.3509 116.02 35.0853 120.423 35.4593L181.059 40.611C184.36 40.8916 186.81 43.7956 186.529 47.0974L183.938 77.5998C183.657 80.9016 180.753 83.3508 177.451 83.0703L138.811 79.7873C130.392 79.072 121.916 79.4596 113.597 80.9402L98.5971 83.6101C97.2146 83.8562 96.6695 81.8901 97.9814 81.3892C104.623 78.8531 109.227 72.7391 109.829 65.6553L111.774 42.7534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.522 42.8168C112.861 38.8272 116.37 35.8677 120.359 36.2066L180.995 41.3584C183.884 41.6038 186.027 44.1449 185.782 47.034L183.19 77.5363C182.945 80.4253 180.404 82.5684 177.515 82.323L138.874 79.04C130.39 78.3192 121.849 78.7098 113.466 80.2018L98.4657 82.8717C98.311 82.8993 98.2207 82.8631 98.1634 82.823C98.0951 82.7752 98.0325 82.6907 98.0016 82.5794C97.9708 82.4681 97.981 82.3634 98.0149 82.2873C98.0433 82.2234 98.1021 82.1459 98.249 82.0898C105.16 79.4511 109.95 73.0894 110.576 65.7188L112.522 42.8168Z",
    stroke: "#C7C7CC",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4960_13183)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 37,
    r: 26,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 37,
    r: 26,
    stroke: "#D12E34",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.763 28.3051L142.237 45.6949M142.237 28.3051L125.763 45.6949",
    stroke: "#D12E34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4960_13183",
    x: 103.565,
    y: 99.433,
    width: 8.33459,
    height: 10.3213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4960_13183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4960_13183",
    x: 49.7184,
    y: 12.2796,
    width: 79.9056,
    height: 96.1312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4960_13183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4960_13183",
    x: 93.2332,
    y: 32.4302,
    width: 97.3178,
    height: 56.2012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4960_13183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4960_13183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4960_13183",
    x: 103,
    y: 8,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4960_13183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4960_13183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4960_13183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendingFailedIcon);
export default __webpack_public_path__ + "static/media/sending-failed-icon.276822a4fc48c86a4e8e3ad601e30bb9.svg";
export { ForwardRef as ReactComponent };